<template lang="pug">
#post-view(v-loading="loading")
  transition(name="fade" appear)
    .post-wrapper(v-loading="!post")
      post(v-if="post" :item="post" :standalone="true")

  #more-posts(v-if="post")
    h3 More posts from {{ post.user.fullname }}
    transition(name="fade" appear)
      profile(v-if="post" :userId="post.user._id" :showUserTile="false")
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";

// Components
import Post from "@/components/Post";
import Profile from "@/components/Profile";

export default {
  name: "PostView",
  components: {
    InfiniteLoading,
    Post,
    Profile
  },
  data() {
    return {
      post: undefined,
      loading: true
    };
  },
  mounted() {
    this.loadPost(this.$route.params.id);
  },
  beforeRouteUpdate(to, from, next) {
    this.loading = true;
    this.loadPost(to.params.id);
    next();
  },
  methods: {
    loadPost(postId) {
      axios
        .get(`${process.env.VUE_APP_API_URL}/photos/${postId}`, {})
        .then(response => {
          if (response.data.photo) {
            this.post = response.data.photo;
            this.loading = false;
          }
        });
    }
  }
};
</script>

<style lang="stylus">
#post-view {
  .post-wrapper {
    min-height: 200px;
    margin-bottom: 5vh;

    +laptopup() {
      margin-top: 5vh;
    }
  }

  #more-posts {
    h3 {
      margin: 0 auto 30px auto;
    }
  }
}
</style>
